// @ts-generator-hash: cc870a84d3f487ef3c430bc0f2020f098554cce05b46442a7bd2672ebc2e3df7
// Generation date: 6/1/2026 6:29:09 AM
// Auto-generated by CSharpToTypeScriptConverter
// Based on type: C06Camera.DL.Helpers.CommentType
export enum CommentType {
  None = 0,
  Request = 10,
  RequestRevision = 15,
  Response = 20,
  PrivateNote = 30,
}
